<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        :disabled="disabledRed"
        @change="onChangeReds($event)"
      />
      <span class="red"></span> Faltosos
      <span
        v-b-tooltip.hover
        title="Sem registro da(s) vacina(s) no sistema."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        :disabled="disabledGreen"
        @change="onChangeGreens($event)"
      />
      <span class="green"></span> Em dias
      <span
        v-b-tooltip.hover
        title="Com registro da(s) vacina(s) no sistema."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: () => {},
    },
    disabledRed: {
      type: Boolean,
    },
    disabledGreen: {
      type: Boolean,
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.$emit('resetarNome', this.setRed)
          this.greens = false
          this.reds = true
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.$emit('exibirVerdes', event.target.checked)
    },
  },
}
</script>

<style></style>
